/* HeyMara redesign — interactivity (vanilla, DOM-driven).
   Ports the React prototype behaviour: FAQ accordion, price configurator,
   consultation cart, testimonial carousel, and client click-to-zoom.
   Safe to run multiple times (per-element bind guards) so it survives
   Shopify theme-editor section reloads. */
(function () {
  "use strict";

  var fmt = function (n) { return "$" + Number(n).toLocaleString("en-US"); };
  var esc = function (s) {
    return String(s == null ? "" : s).replace(/[&<>"']/g, function (c) {
      return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[c];
    });
  };
  var bound = function (el) {
    if (!el || el.dataset.hmBound) return true;
    el.dataset.hmBound = "1";
    return false;
  };

  /* ---------- FAQ accordion (single-open, toggle) ---------- */
  function initFaq(root) {
    var items = (root || document).querySelectorAll(".faq-list .faq-item");
    if (!items.length) return;
    var all = [].slice.call(items);
    all.forEach(function (item) {
      if (bound(item)) return;
      item.addEventListener("click", function () {
        var isOpen = item.classList.contains("open");
        all.forEach(function (i) { i.classList.remove("open"); });
        if (!isOpen) item.classList.add("open");
      });
    });
  }

  /* ---------- Price configurator ---------- */
  function initConfig(root) {
    var cfg = (root || document).querySelector ? (root || document).querySelector("#hm-config") : null;
    if (!cfg && root && root.id === "hm-config") cfg = root;
    cfg = document.getElementById("hm-config");
    if (!cfg || bound(cfg)) return;

    var d = cfg.dataset;
    var num = function (v) { return parseFloat(v) || 0; };
    var base = { Starter: num(d.baseStarter), Advanced: num(d.baseAdvanced), Premium: num(d.basePremium) };
    var page = { Lean: num(d.pageLean), Standard: num(d.pageStandard), Expanded: num(d.pageExpanded) };
    var addMig = num(d.addMigration), addSeo = num(d.addSeo), addBrand = num(d.addBranding), rushPct = num(d.rushPct);
    var pw = function (s) { return (s || "").split(/[^0-9]+/).filter(Boolean).map(Number); };
    var weeks = { Starter: pw(d.weeksStarter), Advanced: pw(d.weeksAdvanced), Premium: pw(d.weeksPremium) };

    var state = { tier: "Advanced", pages: "Standard", migration: true, seo: false, branding: false, rush: false };
    var summary = document.getElementById("hm-config-summary");
    var ctaLabel = summary && summary.dataset.cta ? summary.dataset.cta : "Get a real quote";

    var li = function (s, b) { return '<div class="li"><span>' + esc(s) + "</span><b>" + b + "</b></div>"; };

    function render() {
      if (!summary) return;
      var b = base[state.tier];
      var pageAdd = page[state.pages];
      var migAdd = state.migration ? addMig : 0;
      var seoAdd = state.seo ? addSeo : 0;
      var brandAdd = state.branding ? addBrand : 0;
      var rushAdd = state.rush ? Math.round(b * rushPct / 100) : 0;
      var total = b + pageAdd + migAdd + seoAdd + brandAdd + rushAdd;

      var wk = weeks[state.tier] || [0, 0];
      var extra = (state.seo ? 1 : 0) + (state.branding ? 2 : 0);
      var lo = (wk[0] || 0) + extra, hi = (wk[1] != null ? wk[1] : wk[0] || 0) + extra;
      var tl = (lo === hi ? lo + " wks" : lo + "–" + hi + " wks") + (state.rush ? " (rush)" : "");

      var html = "";
      html += '<div class="totlab">Estimated total</div>';
      html += '<div class="tot">' + fmt(total) + " <small>USD</small></div>";
      html += '<div class="br"></div>';
      html += li(state.tier + " build", fmt(b));
      html += li(state.pages + " page set", fmt(pageAdd));
      if (state.migration) html += li("Migration", fmt(migAdd));
      if (state.seo) html += li("SEO", fmt(seoAdd));
      if (state.branding) html += li("Branding", fmt(brandAdd));
      if (state.rush) html += li("Rush queue", fmt(rushAdd));
      html += '<div class="br"></div>';
      html += li("Estimated timeline", tl);
      html += '<div class="cta"><button class="btn btn-primary">' + esc(ctaLabel) + '<span style="display:inline-block">↗</span></button></div>';
      summary.innerHTML = html;
    }

    cfg.querySelectorAll(".seg").forEach(function (seg) {
      var key = seg.dataset.seg;
      seg.querySelectorAll("button").forEach(function (btn) {
        btn.addEventListener("click", function () {
          state[key] = btn.dataset.val;
          seg.querySelectorAll("button").forEach(function (b2) { b2.classList.toggle("on", b2 === btn); });
          render();
        });
      });
    });
    cfg.querySelectorAll(".toggle").forEach(function (tg) {
      var key = tg.dataset.toggle;
      tg.addEventListener("click", function () {
        state[key] = !state[key];
        tg.classList.toggle("on", state[key]);
        render();
      });
    });
    render();
  }

  /* ---------- Consultation cart ---------- */
  function initConsult(root) {
    var section = document.querySelector(".consult");
    if (!section || bound(section)) return;
    var cards = [].slice.call(section.querySelectorAll(".consult-card[data-pack]"));
    var cartbar = document.getElementById("hm-cartbar");
    var cart = {};
    // "live" = every card is mapped to a real Shopify variant -> use the real cart.
    // Otherwise fall back to a demo-only cart (preview / theme editor before the product exists).
    var live = cards.length > 0 && cards.every(function (c) { return c.dataset.variantId; });

    // unitsPerBlock[pack] = how many Shopify units of the variant equal one "block"
    // (so line total === the block price shown on the card, whatever the variant is priced at).
    var unitsPerBlock = {};
    cards.forEach(function (c) { unitsPerBlock[c.dataset.pack] = 1; });
    var handle = section.dataset.productHandle || "";

    function cardOf(id) { return cards.filter(function (c) { return c.dataset.pack === id; })[0]; }
    function variantOf(id) { var c = cardOf(id); return c ? c.dataset.variantId : ""; }
    function unitsOf(id) { return unitsPerBlock[id] || 1; }
    function noop() {}
    function postJSON(url, body) {
      return fetch(url, {
        method: "POST",
        headers: { "Content-Type": "application/json", "Accept": "application/json" },
        body: JSON.stringify(body)
      });
    }
    function slotProps() {
      var d = document.getElementById("consult-date");
      var t = document.getElementById("consult-time");
      var props = {};
      if (d && d.value) props["Preferred date"] = d.value;
      if (t && t.value) props["Preferred time"] = t.value;
      return Object.keys(props).length ? props : null;
    }
    function shopifyAdd(vid, qty) {
      var item = { id: Number(vid), quantity: qty };
      var p = slotProps();
      if (p) item.properties = p;
      return postJSON("/cart/add.js", { items: [item] });
    }
    function shopifyChange(vid, qty) { return postJSON("/cart/change.js", { id: String(vid), quantity: qty }); }

    function syncDrawer(open) {
      return function () { if (window.HMCart) window.HMCart.refresh({ open: !!open }); };
    }
    function inc(id) {
      var was = cart[id] || 0;
      cart[id] = was + 1; update(id);
      if (live) (was === 0
        ? shopifyAdd(variantOf(id), unitsOf(id))
        : shopifyChange(variantOf(id), cart[id] * unitsOf(id))).then(syncDrawer(true)).catch(noop);
    }
    function dec(id) {
      var n = (cart[id] || 0) - 1;
      if (n <= 0) delete cart[id]; else cart[id] = n;
      update(id);
      if (live) shopifyChange(variantOf(id), Math.max(n, 0) * unitsOf(id)).then(syncDrawer(false)).catch(noop);
    }

    // Read live variant prices so each block adds the quantity whose line total
    // equals the card's block price — correct whether the variant is priced
    // per-hour ($200 → 10 units) or as the block total ($2,000 → 1 unit).
    function syncUnitFactors(done) {
      if (!live || !handle) { done(); return; }
      fetch("/products/" + handle + ".js", { headers: { "Accept": "application/json" } })
        .then(function (r) { return r.json(); })
        .then(function (p) {
          var unit = {};
          (p.variants || []).forEach(function (v) { unit[String(v.id)] = v.price; }); // cents
          cards.forEach(function (c) {
            var u = unit[String(c.dataset.variantId)];
            var blockCents = Math.round((parseFloat(c.dataset.price) || 0) * 100);
            if (u && u > 0 && blockCents > 0) {
              unitsPerBlock[c.dataset.pack] = Math.max(1, Math.round(blockCents / u));
            }
          });
          done();
        })
        .catch(function () { done(); });
    }
    function update(id) {
      var card = cardOf(id);
      if (card) control(card);
      renderBar();
    }

    function control(card) {
      var id = card.dataset.pack;
      var foot = card.querySelector(".consult-foot");
      var old = foot.querySelector(".addcart, .qty");
      var qty = cart[id] || 0;
      var el;
      if (qty > 0) {
        el = document.createElement("div");
        el.className = "qty";
        el.innerHTML =
          '<button aria-label="Remove one">−</button>' +
          "<span>" + qty + "</span>" +
          '<button aria-label="Add one">+</button>';
        el.children[0].addEventListener("click", function () { dec(id); });
        el.children[2].addEventListener("click", function () { inc(id); });
      } else {
        el = document.createElement("button");
        el.className = "addcart";
        el.setAttribute("data-add", id);
        el.textContent = "Add to cart";
        el.addEventListener("click", function () { inc(id); });
      }
      if (old) old.replaceWith(el); else foot.appendChild(el);
    }

    function renderBar() {
      if (!cartbar) return;
      var lines = cards.filter(function (c) { return cart[c.dataset.pack]; });
      if (!lines.length) { cartbar.hidden = true; cartbar.innerHTML = ""; return; }
      var totalHours = 0, total = 0, items = "";
      lines.forEach(function (c) {
        var id = c.dataset.pack, q = cart[id], hrs = parseFloat(c.dataset.hours) || 0, price = parseFloat(c.dataset.price) || 0;
        totalHours += hrs * q; total += price * q;
        items += '<span class="ci">' + q + " × " + hrs + " hrs</span>";
      });
      items += '<span class="ci">= ' + totalHours + " hours</span>";
      cartbar.innerHTML =
        '<div class="items">' + items + "</div>" +
        '<div class="ct"><span class="t">' + fmt(total) + '</span><button class="checkout">Checkout →</button></div>';
      cartbar.hidden = false;
      var co = cartbar.querySelector(".checkout");
      if (co && live) co.addEventListener("click", function () { window.location.href = "/checkout"; });
    }

    cards.forEach(function (card) {
      var btn = card.querySelector(".addcart");
      if (btn) btn.addEventListener("click", function () { inc(card.dataset.pack); });
    });

    // Live mode: learn the unit factors, then reflect what's already in the Shopify cart.
    if (live) {
      syncUnitFactors(function () {
        fetch("/cart.js", { headers: { "Accept": "application/json" } })
          .then(function (r) { return r.json(); })
          .then(function (c) {
            var byVariant = {};
            (c.items || []).forEach(function (it) {
              byVariant[String(it.variant_id)] = (byVariant[String(it.variant_id)] || 0) + it.quantity;
            });
            cards.forEach(function (card) {
              var units = byVariant[String(card.dataset.variantId)] || 0;
              var blocks = units > 0 ? Math.max(1, Math.round(units / unitsOf(card.dataset.pack))) : 0;
              if (blocks > 0) { cart[card.dataset.pack] = blocks; control(card); }
            });
            renderBar();
          })
          .catch(noop);
      });
    }
  }

  /* ---------- Consultation booking calendar ---------- */
  function initConsultCalendar(root) {
    var host = (root || document).querySelector("[data-consult-cal]");
    if (!host || bound(host)) return;

    var body = host.querySelector(".ccal-body");
    var dateInput = host.querySelector("#consult-date");
    var timeInput = host.querySelector("#consult-time");
    if (!body || !dateInput || !timeInput) return;

    var slots = (host.getAttribute("data-slots") || "")
      .split(",").map(function (s) { return s.trim(); }).filter(Boolean);
    var weekends = host.getAttribute("data-weekends") === "true";
    var lead = parseInt(host.getAttribute("data-lead"), 10) || 0;

    var MONTHS = ["January", "February", "March", "April", "May", "June",
      "July", "August", "September", "October", "November", "December"];
    var DOW = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];

    var today = new Date(); today.setHours(0, 0, 0, 0);
    var minDate = new Date(today); minDate.setDate(minDate.getDate() + lead);
    var maxView = new Date(today.getFullYear(), today.getMonth() + 12, 1); // cap forward nav at 1 year
    var view = new Date(minDate.getFullYear(), minDate.getMonth(), 1);
    var selDate = null, selTime = null;

    function sameDay(a, b) {
      return a && b && a.getFullYear() === b.getFullYear() &&
        a.getMonth() === b.getMonth() && a.getDate() === b.getDate();
    }
    function fmtDate(d) {
      return DOW[d.getDay()] + ", " + MONTHS[d.getMonth()] + " " + d.getDate() + ", " + d.getFullYear();
    }
    function isOff(d) {
      if (d < minDate) return true;
      var wd = d.getDay();
      if (!weekends && (wd === 0 || wd === 6)) return true;
      return false;
    }
    function writeState() {
      dateInput.value = selDate ? fmtDate(selDate) : "";
      timeInput.value = (selDate && selTime) ? selTime : "";
    }

    function renderSummary() {
      var el = host.querySelector("[data-summary]");
      if (!el) return;
      if (selDate && selTime) {
        el.innerHTML = '<span class="ccal-dot"></span>Booking <b>' + esc(fmtDate(selDate)) +
          '</b> at <b>' + esc(selTime) + "</b>";
        el.classList.add("is-set");
      } else if (selDate) {
        el.textContent = "Now pick a time.";
        el.classList.remove("is-set");
      } else {
        el.textContent = "Select a day to see available times.";
        el.classList.remove("is-set");
      }
    }

    function renderSlots() {
      var wrap = host.querySelector(".ccal-slots");
      if (!wrap) return;
      if (!selDate || !slots.length) { wrap.hidden = true; wrap.innerHTML = ""; return; }
      wrap.hidden = false;
      wrap.innerHTML = slots.map(function (s) {
        return '<button type="button" class="ccal-slot' + (s === selTime ? " is-sel" : "") +
          '" data-slot="' + esc(s) + '">' + esc(s) + "</button>";
      }).join("");
      [].slice.call(wrap.querySelectorAll(".ccal-slot")).forEach(function (b) {
        b.addEventListener("click", function () {
          selTime = b.getAttribute("data-slot");
          writeState();
          [].slice.call(wrap.querySelectorAll(".ccal-slot")).forEach(function (x) {
            x.classList.toggle("is-sel", x === b);
          });
          renderSummary();
        });
      });
    }

    function render() {
      var first = new Date(view.getFullYear(), view.getMonth(), 1);
      var startPad = first.getDay();
      var daysIn = new Date(view.getFullYear(), view.getMonth() + 1, 0).getDate();
      var prevDisabled = (view.getFullYear() === minDate.getFullYear() && view.getMonth() === minDate.getMonth());
      var nextDisabled = (view.getFullYear() === maxView.getFullYear() && view.getMonth() === maxView.getMonth());

      var html = '<div class="ccal-top">' +
        '<button type="button" class="ccal-nav" data-prev' + (prevDisabled ? " disabled" : "") + ' aria-label="Previous month">&lsaquo;</button>' +
        '<div class="ccal-month">' + MONTHS[view.getMonth()] + " " + view.getFullYear() + "</div>" +
        '<button type="button" class="ccal-nav" data-next' + (nextDisabled ? " disabled" : "") + ' aria-label="Next month">&rsaquo;</button>' +
        "</div>";

      html += '<div class="ccal-dow">' + DOW.map(function (d) { return "<span>" + d + "</span>"; }).join("") + "</div>";

      html += '<div class="ccal-grid">';
      for (var p = 0; p < startPad; p++) html += '<span class="ccal-pad"></span>';
      for (var day = 1; day <= daysIn; day++) {
        var d = new Date(view.getFullYear(), view.getMonth(), day);
        var off = isOff(d), sel = sameDay(d, selDate);
        html += '<button type="button" class="ccal-day' + (off ? " is-off" : "") + (sel ? " is-sel" : "") +
          '"' + (off ? " disabled" : "") + ' data-day="' + day + '">' + day + "</button>";
      }
      html += "</div>";
      html += '<div class="ccal-slots" hidden></div>';
      html += '<div class="ccal-summary" data-summary></div>';
      body.innerHTML = html;

      var prev = body.querySelector("[data-prev]"), next = body.querySelector("[data-next]");
      if (prev && !prevDisabled) prev.addEventListener("click", function () {
        view = new Date(view.getFullYear(), view.getMonth() - 1, 1); render();
      });
      if (next && !nextDisabled) next.addEventListener("click", function () {
        view = new Date(view.getFullYear(), view.getMonth() + 1, 1); render();
      });
      [].slice.call(body.querySelectorAll(".ccal-day:not(.is-off)")).forEach(function (b) {
        b.addEventListener("click", function () {
          selDate = new Date(view.getFullYear(), view.getMonth(), parseInt(b.getAttribute("data-day"), 10));
          selTime = null;
          writeState();
          [].slice.call(body.querySelectorAll(".ccal-day")).forEach(function (x) {
            x.classList.toggle("is-sel", x === b);
          });
          renderSlots();
          renderSummary();
        });
      });
      renderSlots();
      renderSummary();
    }

    render();
  }

  /* ---------- Testimonial carousel ---------- */
  function initCarousel(root) {
    var track = document.getElementById("hm-car-track");
    if (!track || bound(track)) return;
    var prev = document.getElementById("hm-car-prev");
    var next = document.getElementById("hm-car-next");
    var perView = 3;
    var count = track.querySelectorAll(".testi").length;
    var maxIdx = Math.max(0, count - perView);
    var idx = 0;

    function apply() {
      track.style.transform = "translateX(calc(-" + idx + " * (100% + 16px) / " + perView + "))";
      if (prev) prev.disabled = idx === 0;
      if (next) next.disabled = idx === maxIdx;
    }
    if (prev) prev.addEventListener("click", function () { idx = Math.max(0, idx - 1); apply(); });
    if (next) next.addEventListener("click", function () { idx = Math.min(maxIdx, idx + 1); apply(); });
    apply();
  }

  /* ---------- Client click-to-zoom (case studies + shelf chips) ---------- */
  function openZoom(opts) {
    var overlay = document.createElement("div");
    overlay.className = "shelf-zoom";
    var card = document.createElement("div");
    card.className = "shelf-zoom-card" + (opts.wide ? " wide" : "") + (opts.featured ? " featured" : "");
    card.innerHTML =
      '<button class="zx" aria-label="Close">×</button>' +
      '<div class="zimg"></div>' +
      '<div class="zmeta"><span class="t">' + esc(opts.title) + '</span><span class="c">' + esc(opts.sub) + "</span></div>";
    if (opts.image) {
      var zi = card.querySelector(".zimg");
      zi.classList.add("has-img");
      var im = document.createElement("img");
      im.src = opts.image;
      im.alt = opts.title || "";
      zi.appendChild(im);
    }
    overlay.appendChild(card);

    function close() { overlay.remove(); document.removeEventListener("keydown", onKey); }
    function onKey(e) { if (e.key === "Escape") close(); }
    overlay.addEventListener("click", close);
    card.addEventListener("click", function (e) { e.stopPropagation(); });
    card.querySelector(".zx").addEventListener("click", close);
    document.addEventListener("keydown", onKey);
    document.body.appendChild(overlay);
  }

  function initZoom(root) {
    var scope = root && root.querySelectorAll ? root : document;
    scope.querySelectorAll(".case-img[data-case]").forEach(function (img) {
      if (bound(img)) return;
      img.addEventListener("click", function () {
        openZoom({ wide: true, title: img.dataset.zoomTitle || "", sub: img.dataset.zoomSub || "", image: img.dataset.zoomImg || "" });
      });
    });
    scope.querySelectorAll(".shelf-card[data-shelf]").forEach(function (cardEl) {
      if (bound(cardEl)) return;
      cardEl.addEventListener("click", function () {
        var t = cardEl.querySelector(".t"), c = cardEl.querySelector(".c");
        openZoom({
          featured: cardEl.classList.contains("featured"),
          title: t ? t.textContent : "",
          sub: c ? c.textContent : "",
          image: cardEl.dataset.zoomImg || ""
        });
      });
    });
  }

  /* ---------- Cart drawer (global, reflects the real Shopify cart) ---------- */
  var cartDrawerBound = false;
  function money(cents) {
    var n = (Number(cents) || 0) / 100;
    return "$" + n.toLocaleString("en-US", { minimumFractionDigits: n % 1 ? 2 : 0, maximumFractionDigits: 2 });
  }
  function cdEls() {
    return {
      root: document.getElementById("hm-cart-drawer"),
      items: document.getElementById("hm-cd-items"),
      foot: document.getElementById("hm-cd-foot")
    };
  }
  function cdSetBadge(count) {
    [].slice.call(document.querySelectorAll("[data-cart-count]")).forEach(function (b) {
      b.textContent = count;
      b.hidden = !(count > 0);
    });
  }
  function cdOpen() {
    var e = cdEls();
    if (!e.root) return;
    e.root.classList.add("open");
    e.root.setAttribute("aria-hidden", "false");
    document.documentElement.classList.add("cd-lock");
  }
  function cdClose() {
    var e = cdEls();
    if (!e.root) return;
    e.root.classList.remove("open");
    e.root.setAttribute("aria-hidden", "true");
    document.documentElement.classList.remove("cd-lock");
  }
  function cdRender(cart) {
    var e = cdEls();
    if (!e.root) return;
    cdSetBadge(cart.item_count || 0);
    if (!cart.items || !cart.items.length) {
      if (e.items) e.items.innerHTML = '<div class="cd-empty">' +
        '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M3 4h2l2.4 12.4a1.5 1.5 0 0 0 1.5 1.2h8.2a1.5 1.5 0 0 0 1.5-1.2L21 8H6"></path><circle cx="9.5" cy="20.5" r="1.3"></circle><circle cx="18" cy="20.5" r="1.3"></circle></svg>' +
        '<p>Your cart is empty.</p></div>';
      if (e.foot) e.foot.hidden = true;
      return;
    }
    e.items.innerHTML = cart.items.map(function (it, i) {
      var line = i + 1;
      var img = it.image ? it.image + (it.image.indexOf("?") > -1 ? "&" : "?") + "width=160" : null;
      var media = img
        ? '<img class="cd-line-img" src="' + img + '" alt="' + esc(it.product_title) + '" loading="lazy">'
        : '<div class="cd-line-img cd-line-ph" aria-hidden="true">' + esc((it.product_title || "?").charAt(0).toUpperCase()) + "</div>";
      var variant = (it.variant_title && it.variant_title !== "Default Title")
        ? '<div class="cd-line-variant">' + esc(it.variant_title) + "</div>" : "";
      return '<div class="cd-line" data-line="' + line + '">' +
          media +
          '<div class="cd-line-body">' +
            '<div class="cd-line-top">' +
              '<div class="cd-line-title">' + esc(it.product_title) + "</div>" +
              '<button class="cd-remove" aria-label="Remove ' + esc(it.product_title) + '">&times;</button>' +
            "</div>" +
            variant +
            '<div class="cd-line-bottom">' +
              '<div class="cd-qty">' +
                '<button class="cd-step" data-step="-1" aria-label="Decrease quantity">−</button>' +
                "<span>" + it.quantity + "</span>" +
                '<button class="cd-step" data-step="1" aria-label="Increase quantity">+</button>' +
              "</div>" +
              '<div class="cd-line-price">' + money(it.final_line_price) + "</div>" +
            "</div>" +
          "</div>" +
        "</div>";
    }).join("");
    if (e.foot) {
      e.foot.hidden = false;
      var sub = e.foot.querySelector(".cd-subtotal");
      if (sub) sub.textContent = money(cart.total_price);
    }
    [].slice.call(e.items.querySelectorAll(".cd-line")).forEach(function (row) {
      var line = parseInt(row.getAttribute("data-line"), 10);
      var span = row.querySelector(".cd-qty span");
      var cur = span ? parseInt(span.textContent, 10) || 0 : 0;
      [].slice.call(row.querySelectorAll(".cd-step")).forEach(function (b) {
        b.addEventListener("click", function () {
          cdChange(line, Math.max(0, cur + (parseInt(b.getAttribute("data-step"), 10) || 0)));
        });
      });
      var rm = row.querySelector(".cd-remove");
      if (rm) rm.addEventListener("click", function () { cdChange(line, 0); });
    });
  }
  function cdFetch() {
    return fetch("/cart.js", { headers: { "Accept": "application/json" } }).then(function (r) { return r.json(); });
  }
  function cdRefresh(opts) {
    return cdFetch().then(function (c) { cdRender(c); if (opts && opts.open) cdOpen(); return c; }).catch(function () {});
  }
  function cdChange(line, qty) {
    return fetch("/cart/change.js", {
      method: "POST",
      headers: { "Content-Type": "application/json", "Accept": "application/json" },
      body: JSON.stringify({ line: line, quantity: qty })
    }).then(function (r) { return r.json(); }).then(function (c) { cdRender(c); return c; }).catch(function () {});
  }
  function initCartDrawer() {
    var e = cdEls();
    if (!e.root) return;
    if (!cartDrawerBound) {
      cartDrawerBound = true;
      document.addEventListener("click", function (ev) {
        if (ev.target.closest && ev.target.closest("[data-cd-close]")) cdClose();
      });
      document.addEventListener("keydown", function (ev) { if (ev.key === "Escape") cdClose(); });
      window.HMCart = { refresh: cdRefresh, open: cdOpen, close: cdClose, render: cdRender };
    }
    var toggle = document.getElementById("hm-cart-toggle");
    if (toggle && !toggle.dataset.hmBound) {
      toggle.dataset.hmBound = "1";
      toggle.addEventListener("click", function () { cdRefresh({ open: true }); });
    }
    cdRefresh(); // populate badge + contents on load
  }

  /* ---------- Mobile nav (hamburger) ---------- */
  function initNavMobile() {
    var toggle = document.getElementById("hm-nav-toggle");
    var menu = document.getElementById("hm-nav-mobile");
    if (!toggle || !menu || toggle.dataset.hmBound) return;
    toggle.dataset.hmBound = "1";
    function close() {
      menu.classList.remove("open");
      toggle.classList.remove("open");
      toggle.setAttribute("aria-expanded", "false");
      document.documentElement.classList.remove("cd-lock");
    }
    function open() {
      menu.classList.add("open");
      toggle.classList.add("open");
      toggle.setAttribute("aria-expanded", "true");
      document.documentElement.classList.add("cd-lock");
    }
    toggle.addEventListener("click", function () {
      menu.classList.contains("open") ? close() : open();
    });
    var closeBtn = document.getElementById("hm-nav-close");
    if (closeBtn) closeBtn.addEventListener("click", close);
    [].slice.call(menu.querySelectorAll("a, .nav-mobile-cta")).forEach(function (el) {
      el.addEventListener("click", close);
    });
    document.addEventListener("keydown", function (e) { if (e.key === "Escape") close(); });
  }

  function init(root) {
    initFaq(root);
    initConfig(root);
    initConsult(root);
    initConsultCalendar(root);
    initCarousel(root);
    initZoom(root);
    initCartDrawer(root);
    initNavMobile(root);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function () { init(document); });
  } else {
    init(document);
  }

  /* Re-bind when a section is (re)loaded in the Shopify theme editor */
  document.addEventListener("shopify:section:load", function (e) { init(e.target || document); });
})();
